<template>
    <section class="container-fluid">
        <div class="row mcas">
            <div class="col-md-6 col-lg-4 main">
                <div class="row" id="warea">
                    <div class="col-12 invwc">
                        <div class="row comifo myma">
                            <div class="col-6 xtl">
                                <div class="mt-1 mb-2 tf-12 tfcdg">Agent amount</div>
                                <div class="mt-1 mb-2 tfcdb tfw-6 tffss"><span class="tf-28 tfw-7"
                                    id="u_com">{{invite.agentincome}}</span></div>
                            </div>
                            <div class="col-6 pr-2 pt-2 pb-2 jcrdg">
                                <div class="wdcom mb-1" onclick="window.location.href='#/invitewithdraw'">Withdraw</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-4 pt-4 pb-3 bdb6p">
                        <div class="row xtc">
                            <div class="col-6 pt-2 pb-2 bd-r" onclick="window.location.href='#/privilage'">Privilege</div>
                            <div class="col-6 pt-2 pb-2" onclick="window.location.href='#/MyLink'">My Link</div>
                        </div>
                    </div>
                    <div class="col-12 mt-2 bdb6p">
                        <div class="row mr-0 mt-2 plr-0 pt-3 pb-4">
                            <div class="col-6 xtl">
                                <div class="indcard mcpl" onclick="window.location.href='#/InviteRecord'">
                                    <div class="tf-12 tfcdg">Invited today</div>
                                    <div class="tfcdb mb-2 mt-2 tfw-6 tffss"><span class="tf-24 tfw-7"
                                            id="u-int">{{invite.todayinvites}}</span></div>
                                    <div class="tf-12">Total:<span class="pl-1 pr-2 tfw-6" id="u_into">{{invite.totalinvites}}</span><span
                                            class="goRight"></span></div>
                                </div>
                            </div>
                            <div class="col-6 mcpl xtr">
                                <div class="indcard mcpl" onclick="window.location.href='#/DailyIncome'">
                                    <div class="tf-12 tfcdg">Today's income</div>
                                    <div class="tfcdb mb-2 mt-2 tfw-6 tffss"><span class="tf-24 tfw-7"
                                            id="u_tic">{{invite.todaybonus}}</span></div>
                                    <div class="tf-12">Total:<span class="pl-1 pr-2 tfw-6" id="u_ttin">{{invite.totalbonus}}</span><span
                                            class="goRight"></span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-2">
                        <div class="row mr-0 mt-2 ovfh tfwr mb-76">
                            <div class="col-8 mb-2 tf-16 tfcdb xtl">Income details</div>
                            <div class="col-4 pr-4 mb-2 tfcdg xtr"><span class="mcpl comr"
                                onclick="window.location.href='#/IncomeDetails'">more&gt;</span></div>
                            <div class="col-12 pt-2" id="insort">
                                <div class="col-12 pt-4 tfcdg">
                                    <div class="pt-3 tf-14">No records</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12" id="open"></div>
                </div>
                <div class="row" id="odrea"></div>
                <div class="row" id="footer">
                    <div class="col-12 nav-bar adsob" id="adsob">
                        <div class="row">
                            <div class="col-3 pa-0">
                                <div class="navItem" id="moxht2b4u"  onclick="window.location.href='#/'">
                                    <div class="xtc"><span class="icon home" id="home"></span></div>
                                    <div class="xtc">Home</div>
                                </div>
                            </div>
                            <div class="col-3 pa-0">
                                <div class="navItem sel" id="raeiyf2m0"  onclick="window.location.href='#/promotion'">
                                    <div class="xtc"><span class="icon group sel" id="group"></span></div>
                                    <div class="xtc">Invite</div>
                                </div>
                            </div>
                            <div class="col-3 pa-0">
                                <div class="navItem" id="sfrm6bvy"  onclick="window.location.href='#/recharge'">
                                    <div class="xtc"><span class="icon wallet" id="wallet"></span></div>
                                    <div class="xtc">Recharge</div>
                                </div>
                            </div>
                            <div class="col-3 pa-0">
                                <div class="navItem" id="mcpnvd2my"  onclick="window.location.href='#/mine'">
                                    <div class="xtc"><span class="icon my" id="my"></span></div>
                                    <div class="xtc">My</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" id="opffp">
                   
                </div>
                <div class="row" id="anof"></div>
                <div class="row" id="dta_ref"></div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from "axios";
export default {
    name: "PromotionView",
    data() {
        return {
            userdetails: {
                username: null,
                usercode: 0,
                balance: null,
                page: 1,
                level: 1,
                total22: 0
            },
            invite: {

            },
            inviterecord: {

            },
            info: {

            }

        }

    },
    mounted: function prepare() {
        this.getrecord();
    },
    methods: {
        pop(message) {
            document.getElementById("snackbar").innerHTML = message;
            document.getElementById("snackbar").style.display = "";
            setTimeout(function () { document.getElementById("snackbar").style.display = "none"; }, 1000);
        },
        closenotice() {
            document.getElementById("notice").style.display = "none";
        },
        getrecord() {
            this.userdetails.username = localStorage.getItem('username');

            axios.get('https://fiewin.source-code.co.in/Gameapi/src/api/me.php?action=getuserinfo&user=' + this.userdetails.username).then((res) => {
                this.info = res.data.user_Data[0];
                console.log(this.info);

            }).catch((err) => {
                console.log(err);
            })

            axios.get('https://fiewin.source-code.co.in/Gameapi/src/api/bet.php?action=invite&usercode=' + this.userdetails.username).then((res) => {
                this.invite = res.data[0];
                console.log(this.invite);
                if (this.invite.agentincome == 0) {
                    this.invite.agentincome = 0.00;
                }
            }).catch((err) => {
                console.log(err);
            })
        },
     
        up() {
            this.userdetails.page = this.userdetails.page + 1;
            this.getrecord();
        },
        down() {
            if (this.userdetails.page == 1) {
                this.pop("First Page Now!")
            } else {
                this.userdetails.page = this.userdetails.page - 1;
                this.getrecord();
            }

        },
        copylink() {
            this.pop("Success");
            var inputc = document.body.appendChild(document.createElement("input"));
            inputc.value = document.getElementById("link").innerHTML;
            inputc.focus();
            inputc.select();
            document.execCommand('copy');
            inputc.parentNode.removeChild(inputc);
        },
        showlist() {
            document.getElementById("list").style.display = "";
        },
        closelist() {
            document.getElementById("list").style.display = "none";
        }
    }
}

</script>
